import { createStyles } from '@material-ui/core';

const arrowSize = 20;

const AddToHomeScreenAndroidStyles = (theme) => createStyles({
  safariSaveImg: {
    verticalAlign: `sub`,
  },
  bottomDialog: {
    position: `fixed`,
    bottom: theme.spacing(1) * 4,
    margin: 0,
    overflow: `visible`,
    maxWidth: `85%`,
    borderRadius: theme.spacing(1) / 2,
    textAlign: `center`,
  },
});

export default AddToHomeScreenAndroidStyles;
